import React, { useState } from "react";
import styles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showToast } from "../../../components/ToastMsg";
import { createNewOrder } from "../../../redux/features/order/orderServices";
import { getAllCartItems } from "../../../redux/features/cart/cartServices";
import { setShouldRefreshCount } from "../../../redux/features/cart/cartSlice";
import { publicKeyEncryption } from "../../../redux/features/webx/webxService";

const WebxpayPayment = ({ totalAmount }) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.userDetails.details);
  const order = useSelector((state) => state.order.orderDetails.orderResponse);
  const key = useSelector((state) => state.webx.encryption.encryptedCode);

  const [loading, setLoading] = useState(false);

  const custom_fields = btoa('one-time');

  const checkoutOrder = async (event) => {
    event.preventDefault();
    const data = {
      amount: totalAmount,
    };
    try {
      setLoading(true);
      const response = await dispatch(createNewOrder(data)).unwrap();
      if (response.success === true) {
        const plain_text = {
          plaintext: `${response.order.id}|${totalAmount}`
        }
        await dispatch(publicKeyEncryption(plain_text)).unwrap();
        const form = document.getElementById("webxPayForm");
        form.submit();
        setLoading(false);
      } else {
        showToast("error", response.message);
        setLoading(false);
        dispatch(getAllCartItems());
        dispatch(setShouldRefreshCount(true));
      }
    } catch (error) {
      showToast("error", error.message);
      setLoading(false);
      dispatch(getAllCartItems());
      dispatch(setShouldRefreshCount(true));
      showToast('error', error)
    }
  };

  return (
    <form
      action="https://webxpay.com/index.php?route=checkout/billing"
      method="POST"
      id="webxPayForm">
      <input type="hidden" name="return_url" value={`http://mylottery.lk`} />
      <input type="hidden" name="first_name" value={user?.full_name} />
      <input type="hidden" name="last_name" value="MyLottery" />
      <input type="hidden" name="email" value={user.email} />
      <input type="hidden" name="contact_number" value={user.phone_number} />
      <input type="hidden" name="address_line_one" value="46/46, Green Lanka Building" />
      <input type="hidden" name="address_line_two" value="Nawam Mawatha" />
      <input type="hidden" name="city" value="Colombo" />
      <input type="hidden" name="state" value="Western" />
      <input type="hidden" name="postal_code" value="10300" />
      <input type="hidden" name="country" value="Sri Lanka" />
      <input type="hidden" name="process_currency" value="LKR" />
      <input type="hidden" name="payment_gateway_id" value="" />
      <input type="hidden" name="multiple_payment_gateway_ids" value="" placeholder="|seperated ids" />
      <input type="hidden" name="cms" value="PHP" />
      <input type="hidden" name="custom_fields" value={custom_fields} />
      <input type="hidden" name="enc_method" value="JCs3J+6oSz4V0LgE0zi/Bg==" />
      <input type="hidden" name="secret_key" value="53a04eba-4edd-429c-b802-d1bdf10d1e82" />
      <input type="hidden" name="payment" value={key} />
      <input
        type="button"
        value={loading ? `Checking out` : t("Checkout")}
        className={`primary-btn ${styles.purchaseBtn}`}
        onClick={checkoutOrder}
        disabled={loading} />
    </form>
  );
};

export default WebxpayPayment;